import React, { lazy } from "react";
import { Route, Routes as DomRoutes } from "react-router-dom";
import AuthorizePage from "./pages/auth/AuthorizePage";
import TokenPage from "./pages/auth/TokenPage";
import LogoutPage from "./pages/auth/LogoutPage";
import config from "../settings";
import SODetailsPage from "./pages/SODetailsPage";
import AuthLayout from "./layouts/AuthLayout";
import PublicLayout from "./layouts/PublicLayout";
import GeneralAuthLayout from "./layouts/GeneralAuthLayout";
import Page404 from "./pages/404";
import Redirect from "../components/Redirect";

// Old BasePage
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const ListPage = lazy(() => import('./pages/ListPage'));
const DetailPage = lazy(() => import('./pages/DetailPage'));
const ReportPage = lazy(() => import('./pages/ReportPage'));
const BookmarksPage = lazy(() => import('./pages/BookmarksPage'));
const SearchResultsPage = lazy(() => import('./pages/SearchResultsPage'));
const SimpleSearchResultsPage = lazy(() => import('./pages/SimpleSearchResultsPage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage'));
const TripDetailsPage = lazy(() => import('./pages/TripDetailsPage'));
const OrderDetailsPage = lazy(() => import('./pages/OrderDetailsPage'));
const OrderCustomerDetailsPage = lazy(() => import('./pages/OrderCustomerDetailsPage'));

export function Routes() {
    return (
        <DomRoutes>
            <Route path="*" element={<Page404 />} />

            {/* Redirect from root URL to /dashboard.  */}
            <Route exact path="/" element={<Redirect to="/dashboard" />} />

            {/* 
                // PROTECTED ROUTES
                // OLD <BasePage /> Routes (Authorized Routes)
            */}

            <Route element={<GeneralAuthLayout />}>
                <Route element={<AuthLayout />}>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/listpage/:component" element={<ListPage />} />
                    <Route path="/detail/:component/:id/:tab?/:subtab?" element={<DetailPage />} />
                    <Route path="/trip/:id" element={<TripDetailsPage />} />
                    <Route path="/order/:id" element={<OrderDetailsPage />} />
                    <Route path="/order-customer/:id" element={<OrderCustomerDetailsPage />} />
                    <Route exact path="/to/:id" element={<Redirect to="/order/:id" />} />
                    <Route path="/so/:id" element={<SODetailsPage />} />
                    <Route path="/analytics/:component/:workspaceid/:reportid/:pagename" element={<ReportPage />} />
                    <Route path="/analytics/:component" element={<ReportPage />} />
                    <Route path="/bookmarks" element={<BookmarksPage />} />
                    <Route path="/search-results" element={<SearchResultsPage />} />
                    <Route path="/simple-search-results/:searched" element={<SimpleSearchResultsPage />} />
                    <Route path="/settings/:activetab" element={<SettingsPage />} />
                </Route>


            </Route>

            {/* PUBLIC ROUTES */}
            <Route element={<PublicLayout />}>
                <Route path="/authorize" element={<AuthorizePage />} />
                <Route path={config.loginCallbackUrl} element={<TokenPage />} />
                <Route path="/logout" element={<LogoutPage />} />
            </Route>
        </DomRoutes>
    );
}